import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	status: 'disconnected',
	lastMessage: null,
	lastError: null,
	endpoint: null,
};

const socketSlice = createSlice({
	name: 'socket',
	initialState,
	reducers: {
		connect(state, action) {
			state.endpoint = action.payload;
			state.status = 'connecting';
		},
		disconnect(state) {
			state.status = 'disconnected';
		},
		connected(state) {
			state.status = 'connected';
			state.lastError = null;
		},
		disconnected(state) {
			state.status = 'disconnected';
		},
		messageReceived(state, action) {
			state.lastMessage = action.payload;
		},
		errorOccurred(state, action) {
			state.lastError = action.payload;
			state.status = 'error';
		},
	},
});

export const { connect, disconnect, connected, disconnected, messageReceived, errorOccurred } = socketSlice.actions;
export default socketSlice.reducer;


